module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"desktop":"Desktop","mobile":"Mobile","country":"Country (Language)"},"fr":{"desktop":"Bureau","mobile":"Mobile","country":"Pays (Langue)"},"de":{"desktop":"Büro","mobile":"Handy, Mobiltelefon","country":"Zahlt (Sprache)"}}')
  delete Component.options._Ctor
}
